import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE_COM_PAIS } from '../../shared/sociedadeSections';
import pedidoRegistroSociedadeUnipessoalConfig from '../pedidoRegistroSociedadeUnipessoal/config';
import pedidoRegistroSociedadePluripessoalConfig from '../pedidoRegistroSociedadePluripessoal/config';

// A taxa da filial é a mesma do registro da sociedade do tipo escolhido: Unipessoal
// = valor fixo do Registro de Sociedade Individual; Pluripessoal = mesmo valor base
// + valor por sócio a partir do 3º do Registro de Sociedade Pluripessoal. Lido
// direto dos dois configs pra não divergir quando um deles mudar.
const paymentConfig = {
  dynamicAmount: true,
  dynamicField: 'tipoSociedade',
  options: {
    UNIPESSOAL: {
      name: 'Unipessoal',
      amount: pedidoRegistroSociedadeUnipessoalConfig.paymentConfig.amount,
      description: 'Filial de sociedade unipessoal'
    },
    PLURIPESSOAL: {
      name: 'Pluripessoal',
      amount: pedidoRegistroSociedadePluripessoalConfig.paymentConfig.amount,
      description: 'Filial de sociedade pluripessoal',
      quantityPricing: pedidoRegistroSociedadePluripessoalConfig.paymentConfig.quantityPricing
    }
  }
};

const pedidoRegistroFilialSociedadeConfig = {
  id: 'pedido_registro_filial_sociedade',
  nome: 'Pedido de Registro de Abertura de Filial de Sociedade de Advocacia',
  descricao: 'Solicitação de registro de abertura de filial de sociedade de advocacia',
  icon: 'FaFileContract',
  // Categoria "sociedades" (fora dos Registros de Sociedade): só PJ vê — ver acessoPedidoService.js
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contrato', tipoDocumentoProcesso: 538, name: 'Contrato', description: 'Contrato averbado na seccional de origem, assinado pelos sócios via certificação digital e certificado pela seccional de origem', required: true },
      { id: 'dbe', tipoDocumentoProcesso: 375, name: 'DBE - Documento Básico de Entrada', description: 'Documento Básico de Entrada, gerado no site da Redesim', required: true },
      { id: 'copiaDocumentoSocios', tipoDocumentoProcesso: 373, name: 'Cópia do Documento dos Advogados Sócios', description: 'Cópia do documento de identidade de todos os advogados sócios', required: true }
    ]
  },

  paymentConfig,

  protocoloConfig: {
    modeloRequerimento: '328',
    tiposAssunto: '570',
    tipoPedido: '521'
  },

  // Confirmado contra ModeloRequerimentoCampo do 328: "Nome"/"CPFCNPJ" são
  // somenteLeitura (a API preenche a partir do cadastro da PJ) e ficam de fora;
  // o resto é o endereço Comercial, com País.
  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE_COM_PAIS,

  tituloConfig: {
    tipoLancamentoId: 161,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        // Pra PJ, Nome e CNPJ vêm do login e ficam travados (adaptarConfigAoPerfil)
        identificacaoSociedadeSection(),
        {
          title: 'Tipo de Sociedade',
          fields: [
            {
              type: 'radio',
              name: 'tipoSociedade',
              label: 'Esta filial é de uma sociedade:',
              required: true,
              options: [
                { value: 'UNIPESSOAL', label: 'Unipessoal' },
                { value: 'PLURIPESSOAL', label: 'Pluripessoal' }
              ]
            },
            {
              type: 'number',
              name: 'quantidadeSocios',
              label: 'Quantidade de Sócios',
              required: true,
              min: 2,
              step: 1,
              integer: true,
              placeholder: 'Mínimo 2',
              showWhen: { field: 'tipoSociedade', value: 'PLURIPESSOAL' }
            }
          ]
        }
      ]
    },
    enderecoSociedadeStep({ autoCep: true, incluirPais: true, tituloSecao: 'Endereço Profissional' }),
    termosStep()
  ]
};

export default pedidoRegistroFilialSociedadeConfig;
